module.exports = __webpack_public_path__ + "static/img/yeswecan0008.fc7dae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0008.png
// module id = 583
// module chunks = 1